import { EducationalItem } from '../models/educational-content-page.interfaces';
import {
  ChoiceBenefitsMocks,
  EarnMilesMocks,
  PreferredMocks,
  TierMilesMocks,
  UpgradesMocks
} from './educational-entry.mocks';

export const BenefitsMocks: EducationalItem[] = [
  {
    detail:
      'Each tier earns more miles from purchased flights to help you get to your next vacation faster.',
    entry: EarnMilesMocks,
    tierMiles: TierMilesMocks,
    action: {
      url: '',
      label: ''
    }
  },
  {
    detail:
      'Because you’re a Medallion Member, we want to reward you with the best possible seat. With Medallion Status, you’re eligible for Unlimited Complimentary Upgrades for yourself and a companion, to Delta Comfort+® and First Class – anywhere the products are sold.',
    entry: UpgradesMocks,
    action: {
      url: '/us/en/skymiles/medallion-program/medallion-upgrades',
      label: 'Learn More About Complimentary Upgrades'
    }
  },
  {
    detail:
      'A number of choice Main Cabin seats are set aside for eligible passengers. Eligible passengers include Diamond, Platinum, Gold, and Silver Medallion members, SkyTeam® Elite and SkyTeam Elite Plus members, passengers that have purchased full fare Y, M or B class of service, and companions of Preferred Seat-eligible customers.',
    entry: PreferredMocks,
    action: {
      url: '',
      label: ''
    }
  },
  {
    detail:
      'Members who earn Diamond or Platinum Medallion Status through the required flight activity and spend can select their Choice Benefits at the time they earn Status.',
    entry: ChoiceBenefitsMocks,
    action: {
      url: '/content/www/en_US/skymiles/medallion-program/choice-benefits/choice-benefits.html',
      label: 'Learn More About Choice Benefits'
    }
  }
];
